import { render, staticRenderFns } from "./sessao.vue?vue&type=template&id=542d03be"
import script from "./sessao.ts?vue&type=script&lang=js&external"
export * from "./sessao.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542d03be')) {
      api.createRecord('542d03be', component.options)
    } else {
      api.reload('542d03be', component.options)
    }
    module.hot.accept("./sessao.vue?vue&type=template&id=542d03be", function () {
      api.rerender('542d03be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/printModel/sessao.vue"
export default component.exports